import * as React from 'react';
import { useSelector } from 'react-redux';

import { updateChatImages } from '../../../actions/chatImages';
import { BLOB_ID } from '../../../constants/blobId';
import { CHATBOT_ID } from '../../../constants/chatbotId';
import { chatImagesSelector } from '../../../selectors/chatImagesSelector';
import { currentOpenChatIDSelector } from '../../../selectors/currentOpenChatIDSelector';
import { useAppDispatch } from '../../../types/redux/state';

/**
 * Загружает список файлов чата, открытого на сервере (прямая ссылка, iframe),
 * если он ещё не загружался. При открытии из списка чатов список грузит openChatFromListItem.
 * Циан-помощник (CHATBOT_ID) файлов не имеет, а BLOB_ID — ещё не созданный чат,
 * поэтому для них запрос не нужен.
 */
export const useLoadChatImagesOnOpen = (): void => {
  const dispatch = useAppDispatch();
  const chatId = useSelector(currentOpenChatIDSelector);
  const images = useSelector(chatImagesSelector);

  React.useEffect(() => {
    if (chatId && chatId !== CHATBOT_ID && chatId !== BLOB_ID && !images) {
      dispatch(updateChatImages({ chatId }));
    }
    // Только на маунте: при переключении чатов список грузит openChatFromListItem
    // oxlint-disable-next-line react/exhaustive-deps
  }, []);
};
